import createWebsiteAnalysisStorage from "./factory";
import websiteAnalysisStorageProvider from "./provider";

const websiteAnalysisStorage = createWebsiteAnalysisStorage(websiteAnalysisStorageProvider);

export default websiteAnalysisStorage;
